export const isValueExists = value => {
    return value !== null && value !== undefined;
};